<div
  class="category-tabs-wrapper"
  #tabsWrapper
  (wheel)="onWheel($event)"
  (mousedown)="onMouseDown($event)"
  (mouseleave)="onMouseLeave()"
  (mouseup)="onMouseUp()"
  (mousemove)="onMouseMove($event)"
>
  <!-- All tab -->
  <button
    class="cat-tab"
    [class.cat-tab--active]="isSelected(ALL_CATEGORY.cid)"
    (click)="selectCategory(ALL_CATEGORY.cid)"
    [title]="ALL_CATEGORY.name"
  >
    <i class="cat-tab__icon" [ngClass]="getCategoryIcon(ALL_CATEGORY)"></i>
    <span class="cat-tab__label">{{ ALL_CATEGORY.name }}</span>
  </button>

  <!-- Visible categories -->
  <button
    *ngFor="let cat of visibleCategories"
    class="cat-tab"
    [class.cat-tab--active]="isSelected(cat.cid)"
    (click)="selectCategory(cat.cid)"
    [title]="cat.name"
  >
    <i class="cat-tab__icon" [ngClass]="getCategoryIcon(cat)"></i>
    <span class="cat-tab__label">{{ cat.name }}</span>
    <span class="cat-tab__count" *ngIf="cat.count !== undefined">{{ cat.count }}</span>
  </button>

  <!-- More button -->
  <div class="cat-tab__more-wrapper" *ngIf="overflowCategories.length > 0">
    <button
      class="cat-tab cat-tab--more"
      (click)="morePanel.toggle($event)"
      title="More categories"
    >
      <i class="cat-tab__icon pi pi-sliders-h"></i>
      <span class="cat-tab__label">More</span>
      <i class="pi pi-chevron-down cat-tab__more-arrow"></i>
    </button>
  </div>
</div>

<!-- Overflow dropdown using PrimeNG OverlayPanel -->
<p-overlayPanel
  #morePanel
  [appendTo]="'body'"
  styleClass="cat-overflow-overlay"
>
  <ng-template pTemplate="content">
    <div class="cat-overflow-panel">
      <button
        *ngFor="let cat of overflowCategories"
        class="cat-overflow-item"
        [class.cat-overflow-item--active]="isSelected(cat.cid)"
        (click)="selectCategory(cat.cid); morePanel.hide()"
      >
        <i class="cat-overflow-icon" [ngClass]="getCategoryIcon(cat)"></i>
        <span class="cat-overflow-label">{{ cat.name }}</span>
        <span class="cat-overflow-count" *ngIf="cat.count !== undefined">{{ cat.count }}</span>
      </button>
    </div>
  </ng-template>
</p-overlayPanel>
